import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { GetVodafoneOrderRequest, GetVodafoneOrderResponse } from '../models/model'

export class GetOrdersApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'VodafoneReports/GetVodafoneOrdersByIMEI',
      requesterInfo,
    })
  }

  public async getSummaryList(request: GetVodafoneOrderRequest): Promise<GetVodafoneOrderResponse[]> {
    return await this.postAsync<GetVodafoneOrderResponse[]>(request)
  }
}